module.exports = __webpack_public_path__ + "static/media/flag-rectangle-en-UK.e2132738.png";